import React, { useState, useEffect, useContext, useRef }  from 'react';
import { Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import ofertasServices from '../services/ofertasServices';
import postulacionesParaAdminsServices from '../services/postulacionesParaAdminsServices';
import resourcesServices from '../services/resourcesServices';
import MessageModal from './MessageModal';
import { Form } from 'react-bootstrap';
import { errorClassification } from '../errorHandler';
import { useReactToPrint } from 'react-to-print';

const MostrarPostutacion = ({usuarioId, valorOferta, imprimirPostulacion}) => {
  const printComponentRef = useRef();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const [postulacion, setPostulacion] = useState({});
  const [existePostulacion, setExistePostulacion] = useState(false);
  const [oferta, setOferta] = useState(false);
  const [saving, setSaving] = useState(false);
  const [noPuedePostularse, setNoPuedePostularse] = useState(false);
  const [abrirImpresion, setAbrirImpresion] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {
    setOferta(valorOferta)
    if(authInformation.autenticado && authInformation.rol === 'Registrado') {
      obtenerPostulacionUsuario(valorOferta.id)
    }

    setNoPuedePostularse(valorOferta.finalizada_para_postulacion || valorOferta.estado === 'finalizado')

  }, [valorOferta]);

  useEffect(() => {
    if(abrirImpresion && postulacion && postulacion.oferta){
      handlePrint()
      setAbrirImpresion(false)
    }
  }, [abrirImpresion, postulacion]);

  useEffect(() => {
    setExistePostulacion(postulacion.id !== null)
  }, [postulacion]);

  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  });


  const obtenerPostulacionUsuario = async (oferta_id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId(`postulaciones/postulacionUsuario`, oferta_id);

      if(data.oferta.documentaciones.length > 0){
        if (data.adjuntos_postulaciones.length > 0) {
          const adj_not_included = data.oferta.documentaciones.filter(d => !data.adjuntos_postulaciones.map(a => a.documentacion_id).includes(d.id)) 
          if(adj_not_included.length > 0){
            data.adjuntos_postulaciones = data.adjuntos_postulaciones.concat(adj_not_included.map(t => ({documentacion_id: t.id})))
          }
        } else {
          data.adjuntos_postulaciones = data.oferta.documentaciones.map((doc) => ({ documentacion_id: doc.id}))
        }
        
      }

      setPostulacion(data);

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };


  const borrarPostulacion = async () => {
    try {
      setSaving(true)
      await ofertasServices.borrarPostulacion(postulacion.id);
      obtenerPostulacionUsuario(valorOferta.id)
      setSaving(false)

    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const eliminarAdjuntoPostulacion = async (adjuntos_postulacion_id) => {
    try {
      const data = await postulacionesParaAdminsServices.eliminarAdjuntoPostulacion(postulacion.id, adjuntos_postulacion_id);
      setPostulacion(data)
      
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };
  const guardarPostulacion = async () => {
    try {
      if(authInformation.autenticado && authInformation.rol === 'Registrado') {
        setSaving(true)

        const copiaPostulacion = {...postulacion}
        copiaPostulacion.adjuntos_postulaciones_attributes = copiaPostulacion.adjuntos_postulaciones
        delete copiaPostulacion.adjuntos_postulaciones


        // Tamaño máximo permitido (por ejemplo 50 MB)
        const maxSizeMB = 50;
        const maxSizeBytes = maxSizeMB * 1024 * 1024;
        let conError = false
  
        copiaPostulacion.adjuntos_postulaciones_attributes?.forEach((archivo) => {
          if(archivo.archivo && archivo.archivo.size){

            if (archivo.archivo.size > maxSizeBytes) {
              conError = true
              alert(`El archivo de nombre ${archivo.archivo.name} supera el límite de ${maxSizeMB} MB`);
            }
          }
        });

        if(conError){
          setSaving(false)
          return;
        }

        let data;

        if(existePostulacion){
          data = await resourcesServices.actualizarResource('postulaciones', copiaPostulacion.id, {postulacion: copiaPostulacion}, true, 300000);
        } else {
          data = await resourcesServices.crearResource('postulaciones', {postulacion: copiaPostulacion}, true, 300000);
        }

        setSaving(false)

        if(data){
          // setPostulacion(data)
          await obtenerPostulacionUsuario(valorOferta.id)
          setAbrirImpresion(true)
        } else {
          setPostulacion({})
          setAbrirImpresion(false)
        }

      } else {
        handleShowModal(`Tiene que ingresar como registrado. <br />Regístrese si aún no lo ha hecho.`)
      }

    } catch (error) {
      setSaving(false)

      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInputAdjuntosNested = (e, index) => {
    const { name, value, files } = e.target;

    const copiaPostulacion = {...postulacion};
    copiaPostulacion.adjuntos_postulaciones[index][name] = files[0]
    setPostulacion(copiaPostulacion)
  }

  const handleCondiciones = (e) => {

    setPostulacion({...postulacion,
      'estado_condiciones': e.target.checked ? 'aceptadas' : 'sin_condiciones'
    })
  }

  const nombreDocumentacion = (documento_id) => {
    const documento = oferta.documentaciones.filter(doc => doc.id === documento_id)
    return documento[0].nombre
  }

  const tipoDocumentacion = (documento_id) => {
    const documento = oferta.documentaciones.filter(doc => doc.id === documento_id)
    return documento[0].opcional
  }

  return (
    <>
      {
        (authInformation.autenticado) && (
          <div className="mb-3">
            {/* <pre>{JSON.stringify(postulacion, null, 2)}</pre> */}

            {
              !noPuedePostularse && oferta.adjuntos && oferta.adjuntos.filter(ad => !ad.es_condicion).length > 0 && (
                <div className="mx-auto my-3 py-3 border-top border-3">
                  <h3>Para descargar</h3>
                  <ul className='list-group'>
                    {
                      oferta.adjuntos.filter(ad => !ad.es_condicion).map((adjunto, index) => (
                        <li className='list-group-item' key={index}>{adjunto.titulo}:
                        <a href={adjunto.archivoUrl} target="_blank" className="btn btn-link" role="button" aria-disabled="true">Descargar</a>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              )
            }

            {
            !noPuedePostularse && oferta.vigente_para_postulacion && postulacion.adjuntos_postulaciones && postulacion.adjuntos_postulaciones.length > 0 && (
              <div className="my-3 py-3 border-top border-3">
                <h3>Documentación para adjuntar</h3>
                <div className='alert alert-warning'>Cada archivo no deben superar los 50MB y debe estar en formato pdf, doc o docx</div>
                  {
                    postulacion.adjuntos_postulaciones.map((adjunto, index) => (
                      <div key={index} className="">
                        <input
                          value={adjunto.documentacion_id || ''}
                          name={'adjuntos_postulaciones.documentacion_id'}
                          type={'hidden'}
                        />

                        <div className='card mb-3'>
                          <div className='card-body'>
                            <h5 className="card-title">{nombreDocumentacion(adjunto.documentacion_id)}{tipoDocumentacion(adjunto.documentacion_id) ? (<span className="badge text-bg-success ms-3">Opcional</span>) : (<span className="badge text-bg-danger ms-3">Obligatoria</span>)}</h5>
                            <div className='card-text'>
                              {
                                adjunto.archivoUrl ? (
                                  <>
                                  <a href={adjunto.archivoUrl} target="_blank" className="btn btn-info mb-3" role="button" aria-disabled="true">Descargar</a>
                                  <button onClick={()=>eliminarAdjuntoPostulacion(adjunto.id)} target="_blank" className="btn btn-danger ms-1 mb-3" >Eliminar</button>
                                  <div className="alert alert-secondary" role="alert">
                                    Para cambiar de archivo, elimínelo y vuelva a adjuntarlo
                                  </div>
                                  </>
                                ) : (
                                <input
                                  placeholder={adjunto.nombre}
                                  className="form-control"
                                  onChange={(e) => handleInputAdjuntosNested(e, index)}
                                  name="archivo"
                                  type="file"
                                  id={`adjuntos_postulaciones.${index}.archivo`}
                                />
                                )
                              }

                              
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  }
              </div>
              )
            }

            {
            !noPuedePostularse && oferta.adjuntos && oferta.adjuntos.filter(ad => ad.es_condicion).length  > 0 && (
              <div className="my-3 py-3 border-top border-3">
                <h3>Aceptación de condiciones</h3>
                <ol className="list-group list-group-numbered">
                  {
                    oferta.adjuntos.filter(ad => ad.es_condicion).map((condicion, index) => (
                      <li key={index} className="list-group-item">
                        <>
                        {condicion.titulo}
                        {
                          condicion.archivoUrl && (
                            <a href={condicion.archivoUrl} target="_blank" className="btn btn-link" role="button">Leer</a>
                          )
                        }
                        </>
                      </li>
                    ))
                  }
                </ol>
                {
                  existePostulacion && authInformation.rol === 'Registrado' ? (
                    <>
                      {postulacion.estado_condiciones === "aceptadas" && (
                        <div className="alert alert-success" role="alert">
                          Condiciones aceptadas
                        </div>

                      )}
                    </>
                  ) : (
                    <div className="mb-3 form-check">
                      <Form.Check
                        type="switch"
                        value={postulacion.estado_condiciones}
                        onChange={(e) => handleCondiciones(e)}
                        name="estado_condiciones"
                        id="estado_condiciones"
                        label="Acepto las condiciones"
                      />
                    </div>
                  )
                }

              </div>
              )
            }

            {
              oferta.material_estudios_ofertas && oferta.material_estudios_ofertas.length > 0 && (
                <div className="mx-auto my-3 py-3 border-top border-3">
                  <h3>Material de estudio</h3>
                  <ul className='list-group'>
                    {
                      oferta.material_estudios_ofertas.map((meo, index) => (
                        meo.material_estudio && meo.material_estudio.nombre && (
                          <li className='list-group-item' key={index}>{meo.material_estudio.nombre}:
                            <a href={meo.material_estudio.archivoUrl} target="_blank" className="btn btn-link" role="button" aria-disabled="true">Descargar</a>
                          </li>
                        )
                      ))
                    }
                  </ul>
                </div>
              )
            }


          </div>
        )
      }

      <h4 className='text-center mb-3'>{(oferta.fecha_desde && oferta.fecha_hasta) ? `Postulaciones habilitadas entre el ${oferta.fecha_desde_formato_arg} y el ${oferta.fecha_hasta_formato_arg}` : ``}</h4>
      {
        !noPuedePostularse && (
          <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
            {authInformation.autenticado === true && authInformation.rol === 'Registrado' && (
              oferta.tipos === "interno_cerrado" && !authInformation.es_empleado_tribunal ? (
                <>
                <div className="alert alert-danger" role="alert">
                  Este concurso es interno cerrado. Solo para empleados del Tribunal de Cuentas
                </div><br/>
                </>
              ) : (
                <>
                {existePostulacion ? (
                    <>
                      <button disabled={saving} className="btn btn-primary btn-lg px-4 gap-3" type="button" onClick={() => guardarPostulacion()} >
                        {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                        <span role="status">Modificar Postulación</span>
                      </button>
                      <button disabled={saving} className="btn btn-danger btn-lg px-4 gap-3" type="button" onClick={() => borrarPostulacion()} >
                        {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                        <span role="status">Cancelar Postulación</span>
                      </button>
                    </>
                  ) : (
                    oferta.vigente_para_postulacion ? 
                      (
                      <>
                      <button disabled={saving} className="btn btn-primary btn-lg px-4 gap-3" type="button" onClick={() => guardarPostulacion()} >
                        {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                        <span role="status">Quiero postularme</span>
                      </button>
                      </>

                      ) : (
                      <button disabled={true} className="btn btn-primary btn-lg px-4 gap-3" type='button' >Quiero postularme</button>

                      )
                  )
                }
                </>
              )

            )}
            {authInformation.autenticado === true && authInformation.rol === 'Admin' && (
              <>
              <Link className="btn btn-success btn-lg px-4" to={`/oferta/${oferta.id}/edit`}>Editar</Link>
              </>
            )}
            {authInformation.autenticado === false && (
              oferta.vigente_para_postulacion ? 
                (
                <Link className="btn btn-primary btn-lg px-4 gap-3" to={`/ingreso?redirect=${window.location.href}`} >Quiero postularme</Link>

                ) : (
                <button disabled={true} className="btn btn-primary btn-lg px-4 gap-3" type='button' >Quiero postularme</button>

                )
            )}
            <Link className="btn btn-outline-secondary btn-lg px-4" to="/listaOfertas">Volver</Link>
            <button className="btn btn-dark btn-lg px-4" type="button" onClick={() => imprimirPostulacion()} >Imprimir</button>
          </div>
        )
      }


      <div className='d-none'>
        <div className="card m-3" ref={printComponentRef}>
          <div className="card-body">
            <div className="card-text">
              <h5 className='text-uppercase'>Comprobante de postulación</h5>
              {
                postulacion && postulacion.oferta && (
                  <>
                  <h5>Usted ha elegido {postulacion.oferta.titulo || ''}</h5>
                  <div><b>Fecha de aceptación de condiciones:</b> {postulacion.fecha_postulacion}</div>
                  </>
                )
              }
            </div>
            <footer className="blockquote-footer mt-3">Tribunal de cuentas de Neuquén - {postulacion.fecha_servidor || ''}</footer>
          </div>
        </div>
      </div>

      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default MostrarPostutacion;